import { ReactNode } from "react";
import { ErrorBoundary } from "@/core/providers/error-boundary";
import { QueryCacheProvider } from "@/core/providers/query-cache";
import { ServiceLocatorProvider } from "@/shared/providers/service-locator";
import { AuthSessionBootstrap } from "@/modules/auth/ui/AuthSessionBootstrap";

interface AppProviderProps {
  children: ReactNode;
}

export function AppProvider({ children }: AppProviderProps) {
  return (
    <ErrorBoundary>
      <ServiceLocatorProvider>
        <QueryCacheProvider>
          <AuthSessionBootstrap>{children}</AuthSessionBootstrap>
        </QueryCacheProvider>
      </ServiceLocatorProvider>
    </ErrorBoundary>
  );
}
